if (typeof ProductItem !== "function") {
  console.log("Loaded product-item.js");
  class ProductItem extends HTMLElement {
    constructor() {
      super();

      this.productVariants = this.querySelector("product-variants");
      this.priceContainer = this.querySelector("[data-js-product-item-price]");

      console.log("ProductItem initialized", {
        productVariants: this.productVariants,
        priceContainer: this.priceContainer,
        productId: this.dataset.jsProductItem
      });

      if (this.productVariants) {
        // Log available events for debugging
        ["VARIANT_CHANGE", "variant:change", "change"].forEach((eventName) => {
          this.productVariants.addEventListener(eventName, (e) => {
            console.log(`Event fired: ${eventName}`, e);
            this.onVariantChangeHandler(e);
          });
        });

        // Initialize with current variant
        this.onVariantChangeHandler({ target: this.productVariants });
      } else {
        console.warn("No product-variants element found in product-item", this);
      }

      // Fallback: Listen for changes on the product-item itself
      this.addEventListener("change", (e) => {
        console.log("Fallback change event on product-item", e);
        this.onVariantChangeHandler({ target: this.productVariants });
      });
    }

    onVariantChangeHandler(e) {
      console.log("onVariantChangeHandler called", e);
      const variant = e.target?.currentVariant;
      if (variant && this.priceContainer) {
        console.log("Updating price for variant", variant);
        // Hide price to prevent flash
        this.priceContainer.classList.add("price-updating");

        // Get variant metafields from JSON
        const metafieldsData = JSON.parse(
          document.getElementById(`ProductVariantMetafields-${this.dataset.jsProductItem}`).textContent
        );
        const variantMetafields = metafieldsData.variants.find(
          (v) => v.id === variant.id
        );

        // Update price
        if (variantMetafields) {
          const priceElement = this.priceContainer.querySelector(".product-price");
          if (priceElement) {
            priceElement.querySelector("[data-js-product-price-original]").innerHTML =
              this.productVariants._formatMoney(
                variantMetafields.price_per_meter * 100,
                KROWN.settings.shop_money_format
              ) + " / m²";
            const compareElement = priceElement.querySelector("[data-js-product-price-compare]");
            if (
              variantMetafields.meter_compare_at_price >
              variantMetafields.price_per_meter
            ) {
              compareElement.innerHTML = `<span>${this.productVariants._formatMoney(
                variantMetafields.meter_compare_at_price * 100,
                KROWN.settings.shop_money_format
              )}</span>`;
            } else {
              compareElement.innerHTML = "";
            }
            const savingElement = priceElement.querySelector("[data-js-product-price-saving]");
            if (
              variantMetafields.meter_compare_at_price >
              variantMetafields.price_per_meter &&
              savingElement
            ) {
              savingElement.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace(
                "$SAVE_PRICE",
                this.productVariants._formatMoney(
                  (variantMetafields.meter_compare_at_price -
                    variantMetafields.price_per_meter) *
                    100,
                  KROWN.settings.shop_money_format
                )
              )}</span>`;
            } else if (savingElement) {
              savingElement.innerHTML = "";
            }
            priceElement.querySelector("[data-js-product-price-unit]").innerHTML = "";
          }
        }

        // Show price
        this.priceContainer.classList.remove("price-updating");
      } else {
        console.warn("No variant or price container found", { variant, priceContainer: this.priceContainer });
      }
    }
  }

  if (typeof customElements.get("product-item") === "undefined") {
    customElements.define("product-item", ProductItem);
  }
}